import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=8ad49510"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=8ad49510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports